import { useNavigate, useParams } from 'react-router-dom';

import { Button, Modal } from 'antd';

import { useLessonCount } from '@/hooks/useLessonCount';
import { lessonsApi } from '@/services/lesson';
import styled, { StyledProp, css } from '@/styled';

const NotMultipleAccess = (props: StyledProp) => {
  const { id } = useParams();
  const { lessonCount } = useLessonCount();
  const { data: lesson } = lessonsApi.endpoints.getLessons.useQueryState(id);
  const navigate = useNavigate();

  if (lesson?.allow_multiple_access || lessonCount <= 1) {
    return null;
  }

  return (
    <Modal
      className={props.className}
      open={true}
      closable={false}
      centered
      width={857}
      title={'Parece que você esta acessando o Nutror em outros dispositivos'}
      footer={[
        <Button key={'changePassword'} type='primary' size='large' onClick={() => navigate('/perfil')}>
          Alterar Senha
        </Button>
      ]}
    >
      Não é possível assistir uma aula se você estiver em mais de um dispositivo ao mesmo tempo. Caso não seja você,
      altere a senha.
    </Modal>
  );
};

export default styled(NotMultipleAccess)(
  ({ theme }) => css`
    .ant-modal-title {
      font-size: ${theme.space.pxToRem(24)};
      margin-bottom: ${theme.space.pxToRem(24)};
    }
  `
);
